import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class Warranties extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {}
	}

	componentDidMount() {
    document.title = 'Diamonds Direct - Warranties and Guarantees';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  render() {

    return <div className='Warranties'>
      <div className='warPageTitle'>Warranties &amp; Guarantees</div>
      <div className='warBlockWrapper'>
        <div className='warBlock'>
          <div className='warIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/warranties/direct_diamond.png' />
          </div>
          <div className='warTitle'><div>DIRECT DIAMOND IMPORTER</div></div>
          <div className='warBody'>Diamonds Direct is proud to be America's leading direct diamond importer. We have the advantage of being able to pick the best quality diamonds the cutters have to offer. Direct diamond importers can offer lower prices than other jewelry stores because we buy from the original supplier and there is no middleman markup. We can offer a richer selection of diamonds and shapes that may be harder to find at your local jeweler.</div>
        </div>
        <div className='warBlock'>
          <div className='warIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/warranties/personalised_education.png' />
          </div>
          <div className='warTitle'><div>PERSONALIZED EDUCATION</div></div>
          <div className='warBody'>We understand choosing the right diamond is a huge decision, and our diamond experts provide an educational experience that is second to none. Every Diamonds Direct customer receives a personalized diamond education, providing each of our customers the tools and resources needed to select the right diamond for their specifications and budget.</div>
        </div>
        <div className='warBlock'>
          <div className='warIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/warranties/money.png' />
          </div>
          <div className='warTitle'><div>30 DAY MONEY BACK GUARANTEE</div></div>
          <div className='warBody'>If for any reason, you are not satisfied with the purchase of your diamond, return your purchase within 30 days for a full refund. If a special order was manufactured and/or delivered- restocking fees and restrictions may apply, as we are unable to restock jewelry items that are uniquely created or previously worn. Satisfaction is our goal, and we will work on an individual basis with each customer to develop solutions for returned orders.</div>
        </div>
        <div className='warBlock'>
          <div className='warIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/warranties/complementary.png' />
          </div>
          <div className='warTitle'><div>COMPLIMENTARY SERVICES, AFTER THE SALE</div></div>
          <div className='warBody'>Diamonds Direct delivers the highest level of customer service, even after the sale. We offer unrivaled complimentary services, including complimentary jewelry maintenance, complimentary cleaning, complimentary sizing, complimentary appraisal for insurance purposes and complimentary lifetime upgrade on engagement.</div>
        </div>
        <div className='warBlock'>
          <div className='warIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/warranties/liftime_warrenty.png' />
          </div>
          <div className='warTitle'><div>LIFETIME WARRANTY</div></div>
          <div className='warBody'>The lifetime warranty covers all the services for cleaning and tightening, as well as the loss of side diamonds, assuming the loss was not caused by damage. However, even with the warranty, it’s critical to have your jewelry insured in the event of loss, damage or theft. We recommend <a href='https://lavalier.com/' target='_blank'>Lavalier insurance</a>.</div>
        </div>
        <div className='warBlock'>
          <div className='warIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/warranties/lifetime_upgrade.png' />
          </div>
          <div className='warTitle'><div>LIFETIME UPGRADE</div></div>
          <div className='warBody'>Diamonds Direct’s lifetime upgrade allows customers to trade their original engagement diamond, solitaire diamond pendant, and diamond studs for a different size, quality or shape. Think of it as a diamond savings account - you can come in as often as desired to trade in the original diamond and you’re only required to pay the difference between the two diamonds. It’s easy, you get 110% of your original purchase toward your new purchase. Our upgrade policy applies one year after your original purchase and is applicable to natural diamonds only.</div>
        </div>
        <div className='warBlock'>
          <div className='warIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/warranties/risk_free.png' />
          </div>
          <div className='warTitle'><div>RISK-FREE SHOPPING ENVIRONMENT</div></div>
          <div className='warBody'>Diamonds Direct offers a risk-free shopping environment, supported by our 30-Day money back guarantee, on the purchase of a diamond. If within 30 days of your purchase you find a lower price on a diamond with the same quality and specifications anywhere in the United States that is certified by the same laboratory, Diamonds Direct will match the price, terms and conditions. These warranties ensure you get the right diamond at the guaranteed lowest price in the country.</div>
        </div>
        <div className='warBlock'>
          <div className='warIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/warranties/free_delivery.png' />
          </div>
          <div className='warTitle'><div>FREE DELIVERY</div></div>
          <div className='warBody'>Diamonds Direct offers fast, free shipping on all orders placed online, regardless of amount. International customers will be responsible for any duties, VAT, taxes or surcharges levied by their country. Please check with your local authorities to confirm taxes and fees before ordering. Orders for military personnel located overseas will be shipped for free to their APO/FOP. Please keep in mind that these locations are served by the US Post Office and may take up to three weeks to deliver.</div>
        </div>
        <div className='warBlock'>
          <div className='warIcon'>
            <img src='https://ddw2.diamondsdirect.com/img/warranties/financial_option.png' />
          </div>
          <div className='warTitle'><div>FINANCING OPTIONS</div></div>
          <div className='warBody'>Diamonds Direct offers special financing options with approved credit through Wells Fargo Bank, N.A. to help you purchase the jewelry of your dreams. Learn more about the best special financing option for you and <a href='/financing'>apply here</a>.</div>
        </div>
      </div>
    </div>;
	}
}
export default Warranties;

function mapStateToProps(state) {
  return {

  };
}

export const WarrantiesContainer = connect(
  mapStateToProps,
  allActionCreators
)(Warranties);


// WEBPACK FOOTER //
// ./src/components/views/warranties/Warranties.jsx